import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsCards = ({ statistics }) => {
  const cards = [
    {
      title: 'Adressages en attente',
      value: statistics?.totalPending || 0,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      description: 'Nouveaux et en revue'
    },
    {
      title: 'Soumissions aujourd\'hui',
      value: statistics?.dailySubmissions || 0,
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      description: 'Reçus ce jour'
    },
    {
      title: 'Cas urgents',
      value: statistics?.urgentCount || 0,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      description: 'Urgents et urgences',
      highlight: true, // Special highlight for urgent cases
      badge: statistics?.urgentCount > 0 ? 'IA' : null // Show AI badge when urgent cases exist
    },
    {
      title: 'Programmés',
      value: statistics?.byStatus?.scheduled || 0,
      icon: 'Calendar',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      description: 'Rendez-vous fixés'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards?.map((card, index) => (
        <div
          key={index}
          className={`bg-card-elevated border ${
            card?.highlight && card?.value > 0 
              ? 'border-error/30 shadow-lg shadow-error/10' 
              : 'border-white/8'
          } p-6 rounded-xl hover:shadow-xl hover:border-white/12 transition-all duration-300 hover:-translate-y-0.5 relative overflow-hidden`}
        >
          {/* Animated gradient background for urgent cases */}
          {card?.highlight && card?.value > 0 && (
            <div className="absolute inset-0 bg-gradient-to-br from-error/5 via-transparent to-warning/5 animate-pulse" />
          )}
          
          <div className="relative z-10">
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 rounded-xl ${card?.bgColor} flex items-center justify-center shadow-lg ${
                card?.highlight && card?.value > 0 ? 'ring-2 ring-error/30' : ''
              }`}>
                <Icon name={card?.icon} size={24} className={card?.color} />
              </div>
              {card?.badge && (
                <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-purple-500/10 border border-purple-500/30">
                  <Icon name="Sparkles" size={10} className="text-purple-400" />
                  <span className="text-[10px] font-semibold text-purple-400">{card?.badge}</span>
                </div>
              )}
            </div>
            <div>
              <p className={`text-3xl font-bold mb-1 ${
                card?.highlight && card?.value > 0 ? 'text-error' : 'text-primary'
              }`}>
                {card?.value}
              </p>
              <p className="text-sm font-semibold text-secondary mb-1">{card?.title}</p>
              <p className="text-xs text-muted">{card?.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatisticsCards;